import React from 'react';
import ManageBidsContainer from './ManageBidsContainer';
// import ManageBidsOverviewContainer from './ManageBidsOverviewContainer';

class TourHotelManageTab extends React.Component {
  render() {
    return (
      <div className="col-sm-12">
        <ManageBidsContainer
          tourId={this.props.tour.id}
          detail={this.props.detail}
          isTourManager={this.props.isTourManager}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }
}
export default TourHotelManageTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelManageTab.js